module.exports = __webpack_public_path__ + "images/camera.8554e0d81ef2a1eb00e581d2a55c84ac.png";